/* ==========================================================================
   AC Auto Parts — Shopify theme behaviour
   Vanilla JS. Talks to the Shopify AJAX Cart API for add-to-cart and line
   quantity changes; everything else is progressive enhancement over Liquid.
   ========================================================================== */
(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = window.routes || {};

  /* ------------------------------------------------------------- money --- */
  function money(cents) {
    var fmt = window.moneyFormat || "₹{{amount}}";
    var n = (cents / 100);
    var s = n.toFixed(n % 1 === 0 ? 0 : 2);
    var parts = s.split(".");
    var head = parts[0], tail = parts[1] ? "." + parts[1] : "";
    if (head.length > 3) {
      var last3 = head.slice(-3), rest = head.slice(0, -3), grouped = [];
      while (rest.length > 2) { grouped.unshift(rest.slice(-2)); rest = rest.slice(0, -2); }
      if (rest) grouped.unshift(rest);
      head = grouped.join(",") + "," + last3;
    }
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, head + tail);
  }

  /* ------------------------------------------------------------- toast --- */
  var toastTimer;
  function toast(msg) {
    var t = $("[data-toast]"); if (!t) return;
    $("[data-toast-msg]", t).textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* -------------------------------------------------------- cart badge --- */
  function refreshCartBadge() {
    return fetch(routes.cart_url + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$("[data-cart-count]").forEach(function (n) { n.textContent = cart.item_count; });
        $$("[data-cart-total]").forEach(function (n) { n.textContent = money(cart.total_price); });
        return cart;
      })
      .catch(function () { /* offline / preview — leave the Liquid-rendered value */ });
  }

  function addToCart(id, qty) {
    return fetch(routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || "Couldn't add that item."); return; }
        var item = (res.body.items && res.body.items[0]) || res.body;
        toast((item.product_title || item.title || "Item") + " added to cart");
        refreshCartBadge();
      })
      .catch(function () { toast("Network problem — please try again."); });
  }

  /* -------------------------------------------------------- header/nav --- */
  function initChrome() {
    var tog = $("[data-navtoggle]"), mnav = $("[data-mobilenav]");
    if (tog && mnav) tog.addEventListener("click", function () { mnav.classList.toggle("open"); });

    var all = $("[data-allcat]");
    if (all) {
      all.querySelector("button").addEventListener("click", function (ev) {
        ev.stopPropagation(); all.classList.toggle("open");
      });
      document.addEventListener("click", function () { all.classList.remove("open"); });
    }

    // quick add from product cards
    document.addEventListener("click", function (ev) {
      var btn = ev.target.closest("[data-quick-add]");
      if (!btn) return;
      ev.preventDefault();
      var to = btn.getAttribute("data-needs-options");
      if (to) { window.location.href = to; return; }
      btn.disabled = true;
      addToCart(btn.getAttribute("data-quick-add"), 1).then(function () { btn.disabled = false; });
    });

    // filter drawer on mobile
    $$("[data-filter-toggle]").forEach(function (b) {
      b.addEventListener("click", function () {
        var panel = $("[data-filters]", b.closest(".shop"));
        if (panel) panel.classList.toggle("open");
      });
    });

    // native Shopify sort
    $$("[data-sort-native]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var u = new URL(window.location.href);
        u.searchParams.set("sort_by", sel.value);
        u.searchParams.delete("page");
        window.location.href = u.toString();
      });
    });

    // auto-submit storefront filter checkboxes
    var ff = $("#CollectionFilterForm");
    if (ff) {
      $$("input[type=checkbox]", ff).forEach(function (cb) {
        cb.addEventListener("change", function () { ff.submit(); });
      });
    }
  }

  /* ------------------------------------------------------------- hero ---- */
  function initHero() {
    var slides = $$("[data-slide]");
    if (slides.length < 2) return;
    var dots = $$("[data-dot]"), i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("active", k === i); });
      dots.forEach(function (d, k) { d.classList.toggle("active", k === i); });
    }
    function play() { timer = setInterval(function () { go(i + 1); }, 6000); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener("click", function () { stop(); go(k); play(); }); });
    var pv = $("[data-prev]"), nx = $("[data-next]");
    if (pv) pv.addEventListener("click", function () { stop(); go(i - 1); play(); });
    if (nx) nx.addEventListener("click", function () { stop(); go(i + 1); play(); });
    var hero = $(".hero");
    if (hero) { hero.addEventListener("mouseenter", stop); hero.addEventListener("mouseleave", play); }
    play();
  }

  function initRail() {
    $$("[data-rail]").forEach(function (rail) {
      var wrap = rail.closest(".rail-wrap");
      var p = $("[data-rail-prev]", wrap), n = $("[data-rail-next]", wrap);
      if (p) p.addEventListener("click", function () { rail.scrollBy({ left: -524, behavior: "smooth" }); });
      if (n) n.addEventListener("click", function () { rail.scrollBy({ left: 524, behavior: "smooth" }); });
    });
  }

  function initCountdown() {
    var box = $("[data-countdown]"); if (!box) return;
    var h = $("[data-cd-h]"), m = $("[data-cd-m]"), s = $("[data-cd-s]");
    function pad(n) { return n < 10 ? "0" + n : String(n); }
    function tick() {
      var period = 4 * 3600 * 1000;
      var sec = Math.floor((period - (Date.now() % period)) / 1000);
      h.textContent = pad(Math.floor(sec / 3600));
      m.textContent = pad(Math.floor(sec / 60) % 60);
      s.textContent = pad(sec % 60);
    }
    tick(); setInterval(tick, 1000);
  }

  /* -------------------------------------------------------------- PDP ---- */
  function initPDP() {
    var pdp = $("[data-pdp]"); if (!pdp) return;
    var main = $("[data-main]", pdp);

    // gallery
    $$("[data-thumb]", pdp).forEach(function (t) {
      t.addEventListener("click", function () {
        $$("[data-thumb]", pdp).forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        if (main) main.src = t.getAttribute("data-full");
      });
    });

    // quantity
    var qi = $("[data-qty]", pdp);
    function setQ(n) { qi.value = Math.max(1, Math.min(999, n)); }
    var mi = $("[data-qty-minus]", pdp), pl = $("[data-qty-plus]", pdp);
    if (mi) mi.addEventListener("click", function () { setQ((parseInt(qi.value, 10) || 1) - 1); });
    if (pl) pl.addEventListener("click", function () { setQ((parseInt(qi.value, 10) || 1) + 1); });
    if (qi) qi.addEventListener("change", function () { setQ(parseInt(qi.value, 10) || 1); });

    // variant pills -> hidden select
    var sel = $("[data-variant-select]", pdp);
    if (sel) {
      var chosen = [];
      $$(".variants", pdp).forEach(function (group, gi) {
        var active = $("[data-opt-value].active", group);
        chosen[gi] = active ? active.getAttribute("data-opt-value") : null;
      });

      function syncVariant() {
        var want = chosen.join("|");
        var match = null;
        $$("option", sel).forEach(function (o) {
          if (o.getAttribute("data-options") === want) match = o;
        });
        if (!match) return;
        sel.value = match.value;
        var priceEl = $("[data-price]", pdp), cmpEl = $("[data-compare]", pdp);
        if (priceEl) priceEl.textContent = match.getAttribute("data-price");
        if (cmpEl) {
          var c = match.getAttribute("data-compare");
          cmpEl.textContent = c;
          cmpEl.style.display = (c && c !== "" && c !== match.getAttribute("data-price")) ? "" : "none";
        }
        var btn = $("[data-add-btn]", pdp);
        if (btn) {
          var avail = match.getAttribute("data-available") === "true";
          btn.disabled = !avail;
          btn.textContent = avail ? "Add to Cart" : "Sold Out";
        }
        var u = new URL(window.location.href);
        u.searchParams.set("variant", match.value);
        window.history.replaceState({}, "", u.toString());
      }

      $$("[data-opt-value]", pdp).forEach(function (b) {
        b.addEventListener("click", function () {
          var gi = Number(b.getAttribute("data-opt-index"));
          var group = b.closest(".variant-opts");
          $$("[data-opt-value]", group).forEach(function (x) { x.classList.remove("active"); });
          b.classList.add("active");
          chosen[gi] = b.getAttribute("data-opt-value");
          syncVariant();
        });
      });
    }

    // AJAX add to cart from the product form
    var form = $("#ProductForm") || pdp.closest("form");
    if (form) {
      form.addEventListener("submit", function (ev) {
        var submitter = ev.submitter;
        if (submitter && submitter.name && submitter.name !== "add") return; // let dynamic checkout through
        ev.preventDefault();
        var idField = form.querySelector('[name="id"]');
        var btn = $("[data-add-btn]", form);
        if (btn) btn.disabled = true;
        addToCart(idField.value, parseInt(qi ? qi.value : 1, 10) || 1)
          .then(function () { if (btn) btn.disabled = false; });
      });
    }

    // description / spec tabs
    $$("[data-ptab]").forEach(function (b) {
      b.addEventListener("click", function () {
        $$("[data-ptab]").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        var k = b.getAttribute("data-ptab");
        $$("[data-ppanel]").forEach(function (p) { p.classList.toggle("active", p.getAttribute("data-ppanel") === k); });
      });
    });
  }

  /* -------------------------------------------------------------- cart --- */
  function initCart() {
    var form = $("[data-cart-form]"); if (!form) return;

    function changeLine(line, qty) {
      fetch(routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
      }).then(function () { window.location.reload(); })
        .catch(function () { form.submit(); });
    }

    form.addEventListener("click", function (ev) {
      var row = ev.target.closest("[data-line]"); if (!row) return;
      var input = $("[data-line-qty]", row);
      var line = row.getAttribute("data-line");
      if (ev.target.closest("[data-line-inc]")) {
        ev.preventDefault(); changeLine(line, (parseInt(input.value, 10) || 1) + 1);
      } else if (ev.target.closest("[data-line-dec]")) {
        ev.preventDefault(); changeLine(line, Math.max(0, (parseInt(input.value, 10) || 1) - 1));
      }
    });

    $$("[data-line-qty]", form).forEach(function (input) {
      input.addEventListener("change", function () {
        var row = input.closest("[data-line]");
        changeLine(row.getAttribute("data-line"), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
  }

  /* ------------------------------------------------------------- boot ---- */
  function boot() { initChrome(); initHero(); initRail(); initCountdown(); initPDP(); initCart(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", boot);
})();
